import { render } from "./B2bPageDocumentacionDocumentos.vue?vue&type=template&id=2b2db46f&scoped=true&lang=pug"
import script from "./B2bPageDocumentacionDocumentos.vue?vue&type=script&lang=js"
export * from "./B2bPageDocumentacionDocumentos.vue?vue&type=script&lang=js"

import "./B2bPageDocumentacionDocumentos.vue?vue&type=style&index=0&id=2b2db46f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2db46f"]])

export default __exports__